module.exports = __webpack_public_path__ + "static/media/arialItalic.02bce9f1.ttf";